import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '@/shared/components/OkCancelModal';
import Checkbox from '@/shared/components/input/Checkbox';

const messages = defineMessages({
  SearchRelationsInPeppolNetwork: 'Search relations in PEPPOL network',
  SwitchInvoiceStrategyToPeppolIfFoundOnNetwork:
    'Switch the send invoice strategy to PEPPOL for relations that were found on the PEPPOL network. This does not affect the ability to send the invoice by e-mail.',
  RemoveAccountingEmailAddressIfFound:
    'Remove the accounting inbox e-mailaddress from the relation if it was found on the Peppol network (@yukiworks.be, @exactonline.be, @clearfacts.be, @winbooksconnect.be, @odoo.com)',
});

export default class SearchRelationsInPeppolNetworkModal extends Component {
  state = {
    switchInvoiceStrategyIfFound: true,
    removeAccountingEmailAddressIfFound: true,
  };
  static propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  onSave = () => {
    const { switchInvoiceStrategyIfFound, removeAccountingEmailAddressIfFound } = this.state;

    const { onSave } = this.props;

    const model = {
      switchInvoiceStrategyIfFound,
      removeAccountingEmailAddressIfFound,
    };

    return onSave(model);
  };

  render() {
    const { show, onClose, intl } = this.props;
    const { switchInvoiceStrategyIfFound, removeAccountingEmailAddressIfFound } = this.state;

    if (!show) return null;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.SearchRelationsInPeppolNetwork)}
        show={show}
        onClose={onClose}
        onSave={() => this.onSave()}
      >
        <div className="form-horizontal">
          <div className="form-group">
            <Checkbox
              extraClass="col-md-12"
              id="switchInvoiceStrategyIfFound"
              value={switchInvoiceStrategyIfFound}
              onClick={() =>
                this.setState({ switchInvoiceStrategyIfFound: !switchInvoiceStrategyIfFound })
              }
              text={intl.formatMessage(messages.SwitchInvoiceStrategyToPeppolIfFoundOnNetwork)}
            />
          </div>
          <div className="form-group">
            <Checkbox
              extraClass="col-md-12"
              id="removeAccountingEmailAddressIfFound"
              value={removeAccountingEmailAddressIfFound}
              onClick={() =>
                this.setState({
                  removeAccountingEmailAddressIfFound: !removeAccountingEmailAddressIfFound,
                })
              }
              text={intl.formatMessage(messages.RemoveAccountingEmailAddressIfFound)}
            />
          </div>
        </div>
      </OkCancelModal>
    );
  }
}
